import React, { useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Alert from "react-bootstrap/Alert";
import { useSelector } from "react-redux";
// import DateRangePicker from "../../../../DatePickers/DateRangePicker/DateRangePicker";
import EventsAnalysisAPI from "../../../../../api/EventsAnalysisApi";
// import Dropdown from "react-dropdown";
import Cookies from "js-cookie";
import ReactLoading from "react-loading";

// Create Time string like yyyy-mm-dd HH:MM:SS Z
// 0 + ... slice(-2) are for zero padding
const formatTime = (date, utc = false) => {
    if (utc) {
        return (
            `${date.getUTCFullYear()}-` +
            `${("0" + date.getUTCMonth()).slice(-2)}-` +
            `${("0" + date.getUTCDate()).slice(-2)} ` +
            `${("0" + date.getUTCHours()).slice(-2)}:` +
            `${("0" + date.getUTCMinutes()).slice(-2)}:` +
            `${("0" + date.getUTCSeconds()).slice(-2)} UTC`
        );
    } else {
        return `${date.getFullYear()}-${("0" + date.getMonth()).slice(-2)}-${("0" + date.getDate()).slice(
            -2
        )} ${date.toTimeString()}`;
    }
};

export default function RealTimeEvents({ tabData, setTabData, setPlotsOrder }) {
    const token = Cookies.get("Session");

    // extarcting from redux slice
    const { selectedCustomer, selectedFacility, selectedEquipment, equipmentTimezone, showSELMenu } = useSelector(
        (state) => state.equipmentsPortfolio
    );
    const selectedVoltageType = useSelector((state) => state.voltageType.selectedVoltageType);

    const [tag, setTag] = useState("");
    const [duration, setDuration] = useState(10);

    const [realtimeAlert, setRealtimeAlert] = useState({
        color: "blue",
        text: "",
        show: false,
    });

    const isDurationValid = (value) => {
        if (value == null || value === "") {
            return true; // Allow empty input for duration
        }

        // Check if the value is a number and within the range of -60 to 60
        const numValue = parseInt(value, 10);
        return !isNaN(numValue) && numValue >= -60 && numValue <= 60 && numValue !== 0;
    };

    const isTagValid = (value) => {
        const val = String(value);

        if (val.length === 0) return true; // Allow empty input for tag

        const tagRegex = /^[a-zA-Z0-9\_\- ]+$/; // Only alphanumeric characters and underscores

        return tagRegex.test(val);
    };

    const onDurationChange = (event) => {
        const value = event.target.value;

        const durationRegex = /^-?\d*$/; // Allow only numbers, including negative numbers
        if (!durationRegex.test(value)) {
            return; // Ignore invalid input
        }
        setDuration(value);
    };

    const onTagChange = (event) => {
        const value = String(event.target.value);
        if (isTagValid(value)) {
            setTag(value.replace(" ", "_").slice(0, 30));
        }
    };

    const onPlotButtonClick = () => {
        if (!selectedCustomer) {
            setRealtimeAlert({
                color: "primary",
                show: true,
                text: "Select a Customer",
            });
        } else if (!selectedFacility) {
            setRealtimeAlert({
                color: "primary",
                show: true,
                text: "Select a Facility",
            });
        } else if (!selectedEquipment) {
            setRealtimeAlert({
                color: "primary",
                show: true,
                text: "Select an Equipment ",
            });
        } else if (!isDurationValid(duration)) {
            setRealtimeAlert({
                color: "danger",
                show: true,
                text: "Enter a nonzero duration between -60 and 60 seconds",
            });
        } else {
            setRealtimeAlert({ ...realtimeAlert, show: false });

            setTabData((prevData) => {
                return {
                    ...prevData,
                    plotData: {
                        time: [],
                        current: {
                            Ia: [],
                            Ib: [],
                            Ic: [],
                        },
                        voltage_ln: {
                            Va: [],
                            Vb: [],
                            Vc: [],
                        },
                        analysis: {
                            x_axis_a: [],
                            x_axis_b: [],
                            x_axis_c: [],
                            zc_a: [],
                            zc_b: [],
                            zc_c: [],
                        },
                    },
                    isEventsCapturePlotLoading: true,
                    plotMetaData: {
                        selectedEquipment: selectedEquipment,
                        selectedESA: {},
                        analysisType: null,
                        selectedVoltageType: selectedVoltageType,
                        displayEventTimestampLine: false,
                        displayLLCurrent: false,
                        eventTimeIdx: null,
                        compareFlag: false,
                        fileOne: null,
                        fileTwo: null,
                        fileOneEquipment: null,
                        fileTwoEquipment: null,
                        eventTimeIdxTwo: null,
                    },
                    showPlot: true,
                };
            });

            if (duration < 0) {
                getRealtimeEvent(
                    selectedEquipment.location_node_id,
                    tag,
                    Math.abs(duration),
                    selectedVoltageType.value,
                    equipmentTimezone.value
                );
            } else {
                setTimeout(() => {
                    getRealtimeEvent(
                        selectedEquipment.location_node_id,
                        tag,
                        duration,
                        selectedVoltageType.value,
                        equipmentTimezone.value
                    );
                }, duration * 1000);
            }
        }
    };

    const getRealtimeEvent = (location_node_id, tag, duration, v_type, timezone) => {
        EventsAnalysisAPI.getRealtimeEvent(token, location_node_id, tag, duration, v_type, timezone)
            .then((response) => {
                if (response.status === 200) {
                    setTabData((prevData) => {
                        return {
                            ...prevData,
                            plotData: response.data.content.plot_data,
                            showPlot: true,
                            isEventsCapturePlotLoading: false,
                            plotMetaData: {
                                ...prevData.plotMetaData,
                                selectedESA: { label: response.data.content.timestamp },
                            },
                        };
                    });

                    setPlotsOrder({
                        eventsCapture: 1,
                        correlatingEvents: 2,
                        eventsTrending: 3,
                        eventsThreshold: 4,
                        eventsFeaturesPlot: 5,
                        selEventsTrendingPlot: 7,
                    });
                } else {
                    setTabData((prevData) => {
                        return {
                            ...prevData,
                            isEventsCapturePlotLoading: false,
                            showPlot: false,
                        };
                    });
                    setRealtimeAlert({
                        color: "danger",
                        show: true,
                        text: "No Data Found",
                    });
                }
            })
            .catch((err) => {
                setTabData((prevData) => {
                    return {
                        ...prevData,
                        isEventsCapturePlotLoading: false,
                    };
                });
                console.log(err);
            });
    };

    return (
        <div>
            <Row>
                <Col>
                    <h2 className="margin-top-10">Real-time Events</h2>
                </Col>
            </Row>
            <Row>
                <Col className="col-5">
                    <label>Input a tag</label>
                    <br></br>
                    <Form.Control
                        type="string"
                        value={tag}
                        onChange={(newTag) => onTagChange(newTag)}
                        isInvalid={!isTagValid(tag)}
                        disabled={tabData.isEventsCapturePlotLoading}
                    />
                </Col>
                <Col className="col-3">
                    <label>Capture Length in Seconds:</label>
                    <br></br>
                    <Form.Control
                        value={duration}
                        onChange={(newDuration) => onDurationChange(newDuration)}
                        isInvalid={!isDurationValid(duration)}
                        placeholder="10"
                        disabled={tabData.isEventsCapturePlotLoading}
                    />
                    <Form.Control.Feedback type="invalid">Enter a number between -60 and 60</Form.Control.Feedback>
                </Col>
            </Row>

            <Row>
                <Col className="col-2">
                    <br></br>
                    {tabData.isEventsCapturePlotLoading ? (
                        <ReactLoading type="bars" height={50} width={50} color="#007bff" />
                    ) : (
                        <Button variant="primary" onClick={onPlotButtonClick} className="plot_button">
                            Plot
                        </Button>
                    )}
                </Col>
                <Col className="col-5 eventsAlert">
                    <br />
                    <Alert
                        variant={realtimeAlert.color}
                        show={realtimeAlert.show}
                        onClose={() => setRealtimeAlert({ ...realtimeAlert, show: false })}
                        dismissible
                    >
                        {realtimeAlert.text}
                    </Alert>
                </Col>
            </Row>
        </div>
    );
}
